import { pushCallNotificationApi } from "@/utils/apis/doctor/appointment";
import { INotifyEnum, notify } from "@/utils/toaster";

const useCallNotificationApi = () => {
  const handleIncomingCallNotification = async (
    bookingId: string,
    callerName: string,
    callingUserName: string,
    callingUserId: string,
    memberId?: string,
    doctorName?: string,
    patientName?: string,
    patientId?: string
  ) => {
    try {
      const response = await pushCallNotificationApi({
        bookingId,
        callerName: callerName,
        callingUserName,
        callingUserId,
        memberId,
        doctorName,
        patientName,
        patientId,
      });
      if ("result" in response) {
        return response;
      }
      notify(INotifyEnum.ERROR, response?.message);
    } catch (error) {
      notify(INotifyEnum.ERROR, error?.message);
    }
  };
  return { handleIncomingCallNotification };
};

export default useCallNotificationApi;
